<template>
  <aside v-if="trialVisible || canResume" class="registration-notice" aria-label="Configuração e período gratuito">
    <div v-if="trialVisible" class="trial-notice">
      <div class="notice-summary">
        <div class="notice-title">
          <span class="notice-icon" aria-hidden="true"><i :class="trial.active ? 'ph ph-gift' : 'ph ph-clock'"></i></span>
          <strong>{{ trial.active ? `Teste grátis até ${formatDate(trial.ends_at, true)}` : 'Teste grátis encerrado' }}</strong>
        </div>
        <button type="button" class="notice-action" :aria-expanded="detailsOpen" aria-controls="registration-trial-details" @click="detailsOpen = !detailsOpen">
          {{ detailsOpen ? 'Fechar' : 'Detalhes' }}<span class="notice-chevron" :class="{ expanded: detailsOpen }" aria-hidden="true"></span>
        </button>
      </div>
      <div id="registration-trial-details" v-show="detailsOpen" class="trial-details">
        <span v-if="trial.active">Você está nos seus 7 dias grátis, até {{ formatDate(trial.ends_at) }}. Sem cartão ou pagamento durante o teste.</span>
        <span>Primeira cobrança em {{ formatDate(trial.first_billing_date) }}.</span>
        <router-link v-if="$route.path !== '/payment'" to="/payment">Ver meu plano</router-link>
      </div>
    </div>
    <div v-if="canResume" class="journey-notice">
      <strong>Finalize a configuração do seu estabelecimento</strong>
      <button type="button" class="notice-action" aria-label="Continuar configuração" :disabled="busy" @click="resume">{{ busy ? 'Abrindo...' : 'Continuar' }}</button>
    </div>
    <p v-if="error" class="text-danger mb-0" role="alert">{{ error }}</p>
  </aside>
</template>
<script>
import { mapGetters } from 'vuex';
import api from '@/config/axios';
import { firstAllowedPath } from '@/utils/accessControl';
import { apiError } from '@/services/registrationExperience';
export default {
  data: () => ({ busy: false, error: '', detailsOpen: false }),
  computed: {
    ...mapGetters(['getTrial', 'getOnboarding', 'getAllowedPages']),
    trial() { return this.getTrial; },
    trialVisible() { return this.trial && (this.trial.active || new Date(`${this.trial.first_billing_date}T00:00:00`) > new Date()); },
    canResume() {
      return this.getOnboarding?.eligible && this.getOnboarding.status !== 'completed' &&
        [firstAllowedPath(this.getAllowedPages), '/configurations'].includes(this.$route.path);
    },
  },
  watch: { '$route.path'() { this.detailsOpen = false; } },
  methods: {
    formatDate(value, short = false) { return new Date(value.length === 10 ? `${value}T12:00:00` : value).toLocaleDateString('pt-BR', short ? { day: '2-digit', month: '2-digit' } : undefined); },
    async resume() {
      this.busy = true; this.error = '';
      try { await api.axios.post('/api/onboarding/resume'); await this.$store.dispatch('setAuthenticatedUser'); await this.$router.push('/onboarding'); }
      catch (error) { this.error = apiError(error, 'Não foi possível abrir a configuração. Tente novamente.'); }
      finally { this.busy = false; }
    },
  },
};
</script>
<style scoped>
.registration-notice { margin-bottom: 12px; padding: 6px 12px; border: 1px solid #bee6d9; background: #f1fbf6; color: #213f35; border-radius: 10px; overflow-wrap: anywhere; }
.notice-summary, .journey-notice { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.notice-title { display: flex; align-items: center; gap: 8px; min-width: 0; }
.notice-icon { display: inline-flex; align-items: center; justify-content: center; width: 28px; height: 28px; flex-shrink: 0; border-radius: 8px; background: #def3e8; color: #087356; font-size: 18px; }
.notice-summary strong, .journey-notice strong { min-width: 0; font-size: 13px; font-weight: 600; line-height: 1.4; }
.notice-action { display: inline-flex; align-items: center; justify-content: center; gap: 8px; flex-shrink: 0; min-height: 44px; padding: 4px 6px; border: 0; border-radius: 6px; background: transparent; color: #087356; font-size: 13px; font-weight: 600; white-space: nowrap; }
.notice-action:hover { background: #def3e8; }
.notice-action:focus-visible { outline: 2px solid #087356; outline-offset: 2px; }
.notice-chevron { width: 6px; height: 6px; border-right: 1.5px solid currentColor; border-bottom: 1.5px solid currentColor; transform: rotate(45deg); margin-top: -3px; }
.notice-chevron.expanded { transform: rotate(225deg); margin-top: 3px; }
.trial-details { display: flex; flex-direction: column; align-items: flex-start; gap: 6px; padding: 10px 0; border-top: 1px solid #bee6d9; font-size: 13px; line-height: 1.5; }
.trial-details a { color: #087356; min-height: 44px; display: inline-flex; align-items: center; }
.journey-notice:not(:first-child) { border-top: 1px solid #bee6d9; }
</style>
